var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlankPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66663 0.875C9.0118 0.875 9.29163 1.15482 9.29163 1.5V4.83333C9.29163 4.88859 9.31358 4.94158 9.35265 4.98065C9.39172 5.01972 9.44471 5.04167 9.49996 5.04167H12.8333C13.1785 5.04167 13.4583 5.32149 13.4583 5.66667C13.4583 6.01184 13.1785 6.29167 12.8333 6.29167H9.49996C9.11318 6.29167 8.74225 6.13802 8.46876 5.86453C8.19527 5.59104 8.04163 5.22011 8.04163 4.83333V1.5C8.04163 1.15482 8.32145 0.875 8.66663 0.875Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83329 2.125C2.55703 2.125 2.29207 2.23475 2.09672 2.4301C1.90137 2.62545 1.79163 2.8904 1.79163 3.16667V14.8333C1.79163 15.1096 1.90137 15.3746 2.09672 15.5699C2.29207 15.7653 2.55703 15.875 2.83329 15.875H11.1666C11.4429 15.875 11.7078 15.7653 11.9032 15.5699C12.0985 15.3746 12.2083 15.1096 12.2083 14.8333V5.92555L8.40774 2.125H2.83329ZM1.21284 1.54621C1.64261 1.11644 2.22551 0.875 2.83329 0.875H8.66663C8.83239 0.875 8.99136 0.940848 9.10857 1.05806L13.2752 5.22472C13.3924 5.34193 13.4583 5.50091 13.4583 5.66667L13.4583 14.8333C13.4583 15.4411 13.2169 16.024 12.7871 16.4538C12.3573 16.8836 11.7744 17.125 11.1666 17.125H2.83329C2.2255 17.125 1.64261 16.8836 1.21284 16.4538C0.783069 16.024 0.541626 15.4411 0.541626 14.8333V3.16667C0.541626 2.55888 0.783069 1.97598 1.21284 1.54621Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankPage);
export default __webpack_public_path__ + "static/media/blank_page.174d706bd586d720f5c34957c78e16db.svg";
export { ForwardRef as ReactComponent };